import { Listbox } from 'primeng/listbox';
import { Popover } from 'primeng/popover';
import { PrimeTemplate } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { input, inject, output, computed, Component, linkedSignal, ChangeDetectionStrategy } from '@angular/core';

import { ListboxChangeEvent } from 'primeng/types/listbox';

import { SvgIcon } from '../../ui';

const OPTION_ALL_VALUE = 'all';
const OPTION_FOOTER_VALUE = 'footer-value';

@Component({
  selector: 'app-listbox-select',
  templateUrl: './listbox-select.html',
  styleUrl: './listbox-select.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIcon, Listbox, Popover, FormsModule, ReactiveFormsModule, PrimeTemplate],
  host: {
    class: 'listbox-select',
  },
})
export class ListBoxSelect {
  private readonly translateService = inject(TranslateService);

  public placeholder = input<string>(this.translateService.instant('shared.ui.listbox-select.placeholder'));

  public emptyMessage = input<string>(this.translateService.instant('shared.ui.listbox-select.empty_message'));

  public options = input.required<any[]>();

  public selected = input<unknown>(undefined);

  public canCheckAll = input<boolean>(false);

  public activeSelection = input<boolean>(false);

  public optionLabel = input<string>('label');

  public optionValue = input<string>('value');

  public allOptionLabel = input<string>(this.translateService.instant('shared.ui.listbox-select.all_option'));

  public allOptionValue = input<string>(OPTION_ALL_VALUE);

  public footerOptionValue = input<string>(OPTION_FOOTER_VALUE);

  public optionChangeEvent = output<string>();

  protected listBoxValue = linkedSignal(() => this.selected());

  protected allOption = linkedSignal(() => {
    return {
      [this.optionLabel()]: this.allOptionLabel(),
      [this.optionValue()]: this.allOptionValue(),
    };
  });

  protected selectedOption = computed(() => {
    if (this.listBoxValue() === this.allOptionValue()) {
      return this.allOption();
    }

    return this.options().find((option) => option[this.optionValue()] === this.listBoxValue());
  });

  protected togglePopover(panel: Popover, $event: MouseEvent): void {
    panel?.toggle($event);
  }

  protected onChange(panel: Popover, event: ListboxChangeEvent): void {
    panel.hide();

    this.optionChangeEvent.emit(event.value);
  }

  protected selectAllOption(panel: Popover): void {
    panel.hide();

    this.listBoxValue.set(this.allOptionValue());

    this.optionChangeEvent.emit(this.allOptionValue());
  }

  protected emitFooterClick(panel: Popover): void {
    this.optionChangeEvent.emit(this.footerOptionValue());
    panel.hide();
  }
}
